import fragmentPriceRangeFields from './PriceRangeFieldsFragment.gql';
export default `
  query getProductExtendedDatas(
    $filter: ProductAttributeFilterInput
  ) {
    products(filter: $filter) {
      items {
        sku
        ... on BundleProduct {
          items {
            option_id
            title
            sku
            position
            min_options_in_cart
            max_options_in_cart
            required
            options_type
            type
            price_range { ...PriceRangeFields }
            options {
              position
              is_default
              product {
                sku
                name
                type_id
                is_trial
                force_show_trial_price
                trial_duration_span
                trial_duration_qty
                trial_price
                attribute_set_id
                box_description
                short_description {
                  html
                }
                media_gallery {
                  url
                }
                price_range { ...PriceRangeFields }
                ... on ConfigurableProduct {
                  configurable_options {
                    id
                    attribute_id
                    attribute_uid
                    attribute_code
                    attribute_uid
                    label
                    values {
                      value_index
                      label
                      uid
                    }
                  }
                  variants {
                    product {
                      id
                      sku
                      name
                      card_subtitle
                      box_description
                      stock_status
                      no_bzt_export
                      zuora_completed
                      fulfillment_enabled
                      tipo_consegna
                      natura
                      codice_isbn
                      tipo_abbonamento
                      type_id
                      software_anagrafiche
                      startup_cost
                      full_price
                      taglio_quesiti
                      software_module
                      promotional_price
                      discounted_price
                    }
                  }
                }
              }
              configurable_options_prices {
                configurable_option_id
                configurable_option_price
              }
            }
          }
        }
      }
    }
  }
  ${fragmentPriceRangeFields}
`;
